import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import { getIdentityManagementApiRoot } from '../../utils/getIdentityManagementApiRoot';
import { AuthenticationFactorsDto } from '../../interfaces/Dto/AuthenticationFactorsDto';
import transformAuthenticationFactors from './transformAuthenticationFactors';
import Constants from '../../Constants';

export const AuthenticationFactorsResourceInfo: ResourceInfo = {
  name: '/App.features.account.AuthenticationFactorsResource',
  url: `${getIdentityManagementApiRoot(Constants.MfaProfileController)}/factors`,
  dataDst: '/App.features.account.factors',
};

const AuthenticationFactorsResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    {...AuthenticationFactorsResourceInfo}
    {...props}
    transformResponse={(authenticationFactors: AuthenticationFactorsDto) =>
      transformAuthenticationFactors(authenticationFactors)}
  />
);
export default AuthenticationFactorsResource;
